export const introduceData = [
    {
      image: './images/logo.png',
      text: "With more than 10 years of experience in the field of web interface design and website technology in all fields of information technology. TA Software Solutions Company will bring you the best service with international products."
    },
    {
      image: './images/logo_apple.jpg',
      text: "With the cooperation between Rabbit Technologies and Apple in Vietnam, we always bring satisfaction to the product quality as well as the best customer service care."
    },
    {
      image: './images/logo_service.jpg',
      text: "Our commitment to customer service quality is one of the most important things about Rabbit Technologies"
    }
  ];